<template>
  <div class="bg z100">
    <div class="container pa bg_fff" @click.stop>
      <div class="header">
        <div class="title-box">
          <h2 class="title">
            {{ title }}
            <!-- <div v-if="tipsText" class="iconfont icontishi1">
              <p v-html="tipsText"></p>
            </div> -->
          </h2>
          <i class="iconfont iconquxiao" @click="closeFunc()"></i>
        </div>
        <h3 class="subtitle" v-if="subtitle">{{ subtitle }}</h3>
      </div>
      <div class="flexBox">
        <div class="content">
          <div class="item-box" v-if="type === 'hot'">
            <div
              class="item"
              v-for="(item, index) in jobPublishArr"
              :key="index"
            >
              <img class="item-img" :src="item.imgSrc" alt="" />
              <h4 class="item-title">{{ item.title }}</h4>
              <h5 class="item-subtitle">{{ item.subtitle }}</h5>
            </div>
          </div>

          <div class="form-box" v-else-if="type === 'top'">
            <div class="scroll-box">
              <div class="conditions-title" v-if="currentNumber > 100">
                <span class="iconfont iconhouxuanren"></span>
                <p>当前条件下约有 {{currentNumber}}w+ 候选人看到该职位</p>
              </div>
              <div class="conditions-title warning" v-else>
                  <span class="iconfont iconjinggao"></span>
                  <p>当前条件下约有 100w+ 候选人看到该职位，建议放宽筛选条件</p>
                </div>
              <div class="form-item">
                <span class="form-label">学历要求：</span>
                <el-select
                  class="form-input"
                  v-model="selectDegree"

                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in degreeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>


              <div class="form-item" v-if="jobArr[jobIndex].job_nature === '实习' || jobArr[jobIndex].job_nature === '校招'">
                <span class="form-label">毕业时间：</span>
                <el-select class="time-selector" ref="gruatedSelector" multiple v-model="gruatedYear"  clearable placeholder="请选择">
                  <el-option
                    v-for="(item,index) in gruatedYearList"
                    :key="index"
                    :value="item">
                    <div class="graduation">
                      <span :class="gruatedYear.map(target => target.value).indexOf(item.value) > -1 ? 'iconfont iconxuanzhong' : 'iconfont iconweixuanzhong'"></span>
                      <p :class="gruatedYear.map(target => target.value).indexOf(item.value) > -1 ? 'gradactive' : ''">{{item.label}}</p>
                    </div>
                  </el-option>
                </el-select>
                <div class="grad-input" @click="getFocus">{{gruatedYear.map(target => target.value).join(',')}}</div>
              </div>

              <div class="form-item" v-else>
                <span class="form-label">工作时间：</span>
                <el-select
                  class="form-input"
                  v-model="selectWorkExperience"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in experienceList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>



              <div class="form-item-condition">
                <span class="form-label">院校要求：</span>
                <div class="conditions">
                  <div class="conditions-info">
                    <div class="choose-info">
                      <div class="choose-item-list">
                        <p
                          v-for="(item, index) in schoolTagList"
                          :class="
                            selectedTagList.indexOf(item) > -1
                              ? 'items active'
                              : 'items'
                          "
                          :key="index"
                          @click="selectTags(item)"
                        >
                          {{ item }}
                        </p>
                        <span
                          @click="addSchoolStatus = !addSchoolStatus"
                          v-if="!addSchoolStatus"
                          class="iconfont iconjia1"
                        ></span>
                      </div>
                    </div>
                    <!-- 学校选择 -->
                    <div class="school-selector">
                      <div class="selected-school-list">
                        <div
                          class="items"
                          v-for="(item, index) in selectedSchoolList"
                          :key="index"
                        >
                          <p>{{ item._root }}</p>
                          <span
                            @click="selectSchool(item)"
                            class="iconfont iconguanbi"
                          ></span>
                        </div>
                      </div>
                      <el-select
                        ref="schoolSelector"
                        v-if="addSchoolStatus"
                        v-model="selectedSchool"
                        multiple
                        filterable
                        remote
                        reserve-keyword
                        value-key="id"
                        placeholder="输入院校名称可添加指定院校"
                        :remote-method="schoolMethod"
                        :loading="schoolSearchLoading">
                        <el-option
                        v-for="item in schoolSelecotrOptions"
                        :key="item.id"
                        :label="item._root"
                        :value="item">
                        </el-option>
                      </el-select>
                      <div class="input-box" v-if="addSchoolStatus">
                        <el-input ref="schoolInput" type="text" placeholder="输入院校名称可添加指定院校" v-model="SelectorSchoolWords"></el-input>
                      </div>
                    </div>
                    <div class="info-choose"></div>
                  </div>
                </div>
              </div>
              <div class="form-item-condition">
                <span class="form-label">专业要求：</span>
                <div class="conditions">
                  <div class="conditions-info">
                    <div class="choose-info">
                      <div class="choose-item-list">
                        <p  v-for="(item,index) in majorList" :class="selectedMajorList.findIndex(sitem => sitem.id === item.id) > -1 ? 'items active' : 'items'" :key="index" @click="selectMajor(item)">{{item.name}}</p>
                        <span @click="addMajorStatus = !addMajorStatus" v-if="!addMajorStatus" class="iconfont iconjia1"></span>
                      </div>
                    </div>
                    <!-- 专业选择 -->
                    <div class="school-selector">
                      <div class="selected-school-list">
                        <div
                          class="items"
                          v-for="(item, index) in searchMajorList"
                          :key="index"
                        >
                          <p>{{ item.name }}</p>
                          <span
                            @click="delMajorSelect(item)"
                            class="iconfont iconguanbi"
                          ></span>
                        </div>
                      </div>
                      <el-select
                        ref="majorSelector"
                        v-show="addMajorStatus"
                        v-model="selectedMajor"
                        multiple
                        filterable
                        remote
                        reserve-keyword
                        value-key="id"
                        :loading="majorSearchLoading">
                        <el-option
                          v-for="item in majorSelecotrOptions"
                          :key="item.id"
                          :label="item.name"
                          :value="item"      
                          >
                        </el-option>
                      </el-select>
                      <div class="input-box" v-show="addMajorStatus">
                        <el-input ref="majorInput" type="text" placeholder="请输入所需专业" v-model="SelectorMajorWords"></el-input>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="order-info" v-else-if="type === 'pay'">
          <h4>订单信息</h4>
          <p>订 单 号：{{ orderToken }}</p>
          <p>订单类型：{{ orderTypeText }}</p>
          <p>订单价格：￥{{ orderPriceText }}</p>
        </div> -->

          <div
            class="item-box"
            style="padding: 30px 28px 0 28px"
            v-else-if="type === 'phone'"
          >
            <div class="item-flex-box">
              <div
                :class="
                  currentPhoneCard == index
                    ? 'times_card times_card_active'
                    : 'times_card'
                "
                v-for="(item, index) in getPhoneNumberArr"
                :key="index"
                @click="changeNumber(index)"
              >
                <div class="box_border">
                  <div class="phone_discount" v-if="item.discount">
                    限时{{ item.discount }}折
                  </div>
                  <div class="phone_times">
                    <p class="phone_times_number">
                      {{ item.times }}
                      <span class="number_words">次卡</span>
                    </p>
                    <p class="price_one">{{ item.priceForOne }}元/次</p>
                  </div>
                  <div class="phone_prices">
                    <p>￥{{ item.priceCount }}</p>
                    <span class="opacity6" v-if="item.priceBefore"
                      >原价:￥{{ item.priceBefore }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="footer">

      <div class="footer-left">
        <div class="qrcode-box">
          <qrcode-vue class="qrcode" :value="`${host}/pay/type?type=${payType}&orderId=${type === 'phone' ? BuyPhoneOrderToken : orderToken}`" :size="126" />
          <template v-if="type === 'top' && qrcodeMaskVisible">
            <div class="qrcode-mask"></div>
            <p class="qrcode-mask-text">请选择<br />「曝光时间」</p>
          </template>
        </div>
        <div class="price-info">
          <span class="price-value">￥{{ newPriceText }}</span>
          <div class="price-img">
            <img src="https://files.wondercv.com//web/member/wechat.png" alt="">
            <img src="https://files.wondercv.com//web/member/alipay.png" alt="">
          </div>
          <p class="price-text">使用支付宝/微信，扫码支付</p>
        </div>
      </div>

      <div class="footer-right" v-if="!qrcodeMaskVisible || (type === 'hot') || (type === 'pay') || (type === 'phone')">
        <div class="paid-button" @click="checkOrder('buttonClick')">我已支付</div>
          <p class="paid-text">遇到问题？<span class="color_f64 cursor_p" @click="errorMessage()">咨询客服</span></p>
          <p class="paid-text">销售顾问：010-53686376</p>
        </div>

        </div> -->
      </div>
      <div class="dialog-buttons">
        <p class="cancle-button" @click="closeFunc()">取消</p>
        <p class="confirm-button" @click="submitEdit">保存</p>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import actions from "@/actions/index";
import  hotJobPro  from '@/assets/js/constant.js'
// import qrcodeVue from 'qrcode-vue'
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
const lodash = require("lodash")
export default {
  name: "TipsBlock",
  data() {
    return {
      multipleNumber:{ //选择条件时 人数乘以的倍数
        degree:1,
        edu_time:1,
        school:1,
        major:1,
        work:1
      },
      currentNumber:1000,//有多少万人看到该职位
      moment,
      host: null,
      timer: null,
      selectTopJobTokenAndEndAt: null, // 包含 需要曝光的职位的 token 和 结束日期 的字符串
      selectTopJobToken: null, // 选择需要曝光的职位的 token
      selectTopJobTime: null, // 选择需要曝光的职位的 曝光时间
      selectTopJobEndAt: null, // 选择需要曝光的职位的 结束时间
      selectTopJobTimeRange: [], // 当前职位 可选曝光时间范围
      isPending: false, // 是否正在请求接口

      orderTokenForCondition:'',//订单token
      selectDegree:'', //选择需要曝光的职位的 最低学历要求
      selectWorkExperience:'', //选择需要曝光的职位的 工作经验
      schoolTagList:['不限','985','211','海外前100'],//院校要求 选项
      selectedTagList:['不限'], //已选院校要求
      majorList:[
        {
          id:0,
          name:'不限'
        }
      ], //专业要求选项  位置同学校tags
      selectedMajorList:[
        {
          id:0,
          name:'不限'
        }
      ],//已选专业要求
      qrcodeMaskVisibleForCondition:false,//刷新遮罩层是否显示
      SelectorSchoolWords:'',//学校选择器输入的值
      addSchoolStatus:false,  //添加学校选择器
      selectedSchool:[],//选择器选择的学校
      selectedSchoolList:[],//选择器已选择的学校列表
      schoolSelecotrOptions:[], //学校选择器的选项列表
      schoolSearchLoading:false,//学校选择器的loading样式
      gruatedYear:[{label:'不限',value:'不限'}],//毕业时间
      gruatedYearList:[],//毕业时间选项列表
      addMajorStatus:false,  //添加专业选择器
      selectedMajor:[],//选择器选择的专业
      newMajorSelect:{}, //本次选择的专业
      searchMajorList:[],//选择器已选择的专业列表
      majorSelecotrOptions:[], //专业选择器的选项列表
      majorSelecotrOptionsCopy: [],
      majorSearchLoading:false,//专业选择器的loading样式
      SelectorMajorWords:'',//专业选择器输入的值
      jobInfo:{},//当前选中的职位
      degreeList:[ //学历
        {
          label:'不限',
          value:''
        },
        {
          label:'中专',
          value:'中专'
        },
        {
          label:'高中',
          value:'高中'
        },
        {
          label:'大专',
          value:'大专'
        },
        {
          label:'本科',
          value:'本科'
        },
        {
          label:'硕士',
          value:'硕士'
        },
        {
          label:'博士',
          value:'博士'
        },
        {
          label:'MBA',
          value:'MBA'
        }], //学历
      experienceList:[ //工作经历
        {
          label:'不限',
          value:''
        },
        {
          label:'应届生',
          value:',0'
        },
        {
          label:'1年以下',
          value:'0,1'
        },
        {
          label:'1-3年',
          value:'1,3'
        },
        {
          label:'3-5年',
          value:'3,5'
        },
        {
          label:'5-10年',
          value:'5,10'
        },
        {
          label:'10年以上',
          value:'10,'
        }
      ],
      jobPublishArr: [
        {
          imgSrc:
            "https://files.wondercv.com/b-pc/job-%20publish-pay-item1.png",
          title: "刷新职位",
          subtitle: "不限次数免费刷新",
        },
        {
          imgSrc:
            "https://files.wondercv.com/b-pc/job-%20publish-pay-item2.png",
          title: "搜索人才",
          subtitle: "不限人数免费搜索",
        },
        {
          imgSrc:
            "https://files.wondercv.com/b-pc/job-%20publish-pay-item3.png",
          title: "查看简历",
          subtitle: "不限份数免费查看",
        },
        {
          imgSrc:
            "https://files.wondercv.com/b-pc/job-%20publish-pay-item4.png",
          title: "发起沟通",
          subtitle: "不限数量免费沟通",
        },
      ],
      currentPhoneCard: 0, //当前选中购买的次卡
      getPhoneNumberArr: [
        {
          times: "50", //次数
          priceForOne: "21", //每次的价格
          priceCount: "1050", //现价
          priceBefore: "1500", //原价
          discount: "7", //折扣
          plan_text: "view_phone_50",
        },
        {
          times: "30",
          priceForOne: "22.5",
          priceCount: "675",
          priceBefore: "900",
          discount: "7.5",
          plan_text: "view_phone_30",
        },
        {
          times: "20",
          priceForOne: "24",
          priceCount: "480",
          priceBefore: "600",
          discount: "8",
          plan_text: "view_phone_20",
        },
        {
          times: "10",
          priceForOne: "30",
          priceCount: "300",
          plan_text: "view_phone_10",
        },
        {
          times: "3",
          priceForOne: "30",
          priceCount: "90",
          plan_text: "view_phone_3",
        },
      ],
      newPriceText: this.orderPriceText,
      // 是否是火爆职位
      hotJobs: hotJobPro.hotJobProfessionIds
    };
  },
  props: {
    // 订单token
    orderToken: {
      type: String,
    },
    // 支付类型
    // 可能的值
    // bJobHot 火爆职位
    // bJobTop 精准曝光
    // bPhone  购买电话
    // bHotAndTop 火爆职位+精准曝光
    payType: {
      type: String,
    },
    // 类型：hot 发布火爆职位 或 top 精准曝光 pay 在订单页的支付弹窗
    type: {
      type: String,
    },
    // 标题
    title: {
      type: String,
    },
    // 副标题
    subtitle: {
      type: String,
    },
    // tips文本
    tipsText: {
      type: String,
    },
    // 订单类型文本
    orderTypeText: {
      type: String,
    },
    // 订单价格文本
    orderPriceText: {
      type: Number,
    },
    // 职位列表
    jobArr: {
      type: Array,
      default: () => [],
    },
    // 当前点击曝光的职位 在 职位列表 里的索引
    jobIndex: {
      type: Number,
    },
  },
  computed: {
    // 是否显示二维码遮罩层
    qrcodeMaskVisible() {
      return !(this.selectTopJobToken && this.selectTopJobTime);
    },
    ...mapState("block", ["BuyPhoneOrderToken"]),
  },
  components: {
    // qrcodeVue
  },
  created() {
    this.host = window.location.origin.replace("www", "m");
    // this.host = 'https://m.wondercv.cn'
    // 禁止页面滚动
    document.body.style.position = "static";
    document.body.style.overflow = "hidden";
    this.majorMethodFunc = lodash.debounce(this.majorMethodFunc, 300)
    this.getCondition()
  },
  mounted() {
    // 发布火爆职位，打开弹窗就开始不断监听订单状态
    if (this.type === "hot" || this.type === "pay" || this.type === "phone") {
      // this.openCheck()
    }
    var date = new Date();
    var thisYear = date.getFullYear()
    this.gruatedYearList.push(
      {label:'不限',value:'不限'},
      {label:thisYear-1+'届',value:thisYear-1},
      {label:thisYear+'届',value:thisYear},
      {label:thisYear+1+'届',value:thisYear+1},
      {label:thisYear+2+'届',value:thisYear+2},
      {label:thisYear+3+'届',value:thisYear+3})
      if(this.jobArr[this.jobIndex].graduate_times.length > 0){
        this.gruatedYear.splice(this.gruatedYear.map(target => target.value).indexOf('不限'),1)
        for(let i = 0;i<this.jobArr[this.jobIndex].graduate_times.length;i++){
          let index = this.gruatedYearList.map(target => target.value).indexOf(this.jobArr[this.jobIndex].graduate_times[i] * 1)
          if(index > -1){
            this.gruatedYear.splice(index,1)
          } else{
            this.gruatedYear.push(this.gruatedYearList[index])
          }
        }
      }
    // 曝光职位，只有当 选择了 职位 和 时间，并且更新订单成功后，才会监听订单状态
    // 重新选择了职位，需要关闭监听，因为曝光时间被重置了 为null
    // 重新选择曝光时间，需要关闭监听，然后调更新订单接口，更新订单成功后，再开启监听
  },
  beforeDestroy() {
    // 清除定时器
    // this.closeCheck();
    // 接触禁止页面滚动
    document.body.style.position = "initial";
    document.body.style.overflow = "initial";
  },
  methods: {
    ...mapMutations("block", [
      "updatePhoneNumberToken",
      "updatePhoneNumberStateFun",
      "updatePhoneNumber",
    ]),
    // 开启监听
    // openCheck () {
    //   this.timer = setInterval(() => {
    //     this.checkOrder()
    //   }, 3000)
    // },
    // 关闭监听
    // closeCheck () {
    //   clearInterval(this.timer)
    // },
    //人数--选择学校的变化
    changeSchoolTagNumber(){
      //如果选中不限
      if(this.selectedTagList[0] === '不限'){
        this.multipleNumber.school = 1
      }
      //如果学校tag已选
      if(this.selectedTagList.length > 0 && this.selectedTagList[0] !== '不限'){
        let number = 0
        if(this.selectedTagList.indexOf('985') > -1) number += 0.1
        if(this.selectedTagList.indexOf('211') > -1) number += 0.25
        if(this.selectedTagList.indexOf('海外前100') > -1) number += 0.1
        number += (this.selectedSchoolList.length * 0.01)
        this.multipleNumber.school = number
      }
    },
    //人数--选择专业的变化
    changeMajorNumber(){
      if(this.selectedMajorList[0].id === 0){
        this.multipleNumber.major = 1
      }
      if(this.selectedMajorList.length > 0 && this.selectedMajorList[0].id !== 0){
        this.multipleNumber.major = 0.01 * (this.searchMajorList.length + this.selectedMajorList.length)
      }
    },
    //人数--选择毕业时间的变化
    changeEduTimeNumber(){
      if(this.gruatedYear[0].value === '不限'){
        this.multipleNumber.edu_time = 1
      }
      if(this.gruatedYear.length > 0 && this.gruatedYear[0].value !== '不限'){
        let number = 0
        var date = new Date();
        var thisYear = date.getFullYear()
        if(this.gruatedYear.map(target => target.value).indexOf(thisYear - 1) > -1) number += 0.1
        if(this.gruatedYear.map(target => target.value).indexOf(thisYear) > -1) number += 0.2
        if(this.gruatedYear.map(target => target.value).indexOf(thisYear + 1) > -1) number += 0.11
        if(this.gruatedYear.map(target => target.value).indexOf(thisYear + 2) > -1) number += 0.04
        if(this.gruatedYear.map(target => target.value).indexOf(thisYear + 3) > -1) number += 0.02
        this.multipleNumber.edu_time = number
      }
    },
    sumCount(){
      this.currentNumber = parseInt(1000 * this.multipleNumber.degree * this.multipleNumber.edu_time * this.multipleNumber.major * this.multipleNumber.school * this.multipleNumber.work)
    },
    getFocus(){
      this.$refs.gruatedSelector.toggleMenu()
    },
    //获取condition信息
    async getCondition(){
      let res = await actions.recruit_infos.get_job_conditions({job_token:this.jobArr[this.jobIndex].token})
      let ress = await actions.company.get_majorList()
      if(ress.code == 1000) {
        this.majorSelecotrOptionsCopy = ress.data.major_list
        this.majorList = [...this.majorList, ...ress.data.default_major]
      }
      // console.log(res,'ress')
      this.selectDegree = res.data.degree_name === '' ? '' : res.data.degree_name
      this.selectedTagList = res.data.tag_names.length === 0 && res.data.edu_names.length === 0 ? ['不限'] : res.data.tag_names
      this.selectedSchoolList = res.data.edu_names
      if(res.data.end_at_list.length === 0){
        this.gruatedYear = [{label:'不限',value:'不限'}]
      }else{
        // 先初始化空数组（解决实习职位多出一个不限的问题）
        this.gruatedYear = []
        res.data.end_at_list.forEach((item,index)=>{
          if(this.gruatedYearList.map(target => target.value).indexOf(item) > -1){
            this.gruatedYear.push(this.gruatedYearList[this.gruatedYearList.map(target => target.value).indexOf(item)])
          }
        })
      }
      if(res.data.major_l1s.length !== 0){
        // this.selectedMajorList.splice(this.selectedMajorList.map(target => target.id).indexOf(0),1)

        // for(let i = 0;i <res.data.major_l1s.length;i++){
        //   if(this.majorList.map(target => target.id).indexOf(res.data.major_l1s[i].id) > -1){
        //     this.selectedMajorList.push(res.data.major_l1s[i])
        //   }else{
        //     this.searchMajorList.push(res.data.major_l1s[i])
        //   }
        // }

        // 找默认的几个专业有那几个选中了
        this.selectedMajorList = res.data.major_l1s.filter(item => {
          return !!ress.data.default_major.find(sitem => sitem.id == item.id)
        })
        // 自己搜索选中的
        this.searchMajorList = res.data.major_l1s.filter(item => {
          return !this.selectedMajorList.find(sitem => item.id == sitem.id) 
        })
        this.selectedMajor = [...this.searchMajorList]
      }else{
        this.selectedMajorList = [{id:0,name:'不限'}]
      }
      if(res.data.experience === '经验不限'){
        this.selectWorkExperience = ''
      }else{
        let index = this.experienceList.map(target => target.label).indexOf(res.data.experience)
        this.selectWorkExperience = this.experienceList[index].value
      }
      this.orderTokenForCondition = res.data.order_token
      // console.log(res.data.order_token)
    },
    //保存修改
    async submitEdit(){
      this.addSchoolStatus = false
      this.addMajorStatus = false
      for(let i = 0;i<this.selectedSchoolList.length;i++){
        delete this.selectedSchoolList[i].highlight
      }
      let major_name_list = []
      if(this.selectedMajorList.length === 1 && this.selectedMajorList[0].id === 0){
        major_name_list = []
      }else{
        major_name_list = [...this.selectedMajorList,...this.searchMajorList]
      }
      for(let i = 0;i<major_name_list.length;i++){
        delete major_name_list[i].highlight
      }
      let experience  = this.selectWorkExperience
      if(this.jobArr[this.jobIndex].job_nature === '实习' || this.jobArr[this.jobIndex].job_nature === '校招') experience = ''
      let end_at_list = this.gruatedYear[0].value === '不限' ? [] : this.gruatedYear.map(target => target.value)
      if(this.jobArr[this.jobIndex].job_nature === '全职') end_at_list = []
      let data = {
        order_token: this.orderTokenForCondition,
        degree_name:this.selectDegree === '不限' ? '' : this.selectDegree,
        experience:experience,
        tag_names:this.selectedTagList[0] === '不限' ? [] : this.selectedTagList,
        edu_names:this.selectedSchoolList,
        major_l1s:major_name_list.map(item => {
          return {id: item.id, name: item.name}
        }),
        end_at_list,
        job_token:this.jobArr[this.jobIndex].token
      }
      let res = await actions.recruit_infos.update_order_condition(data)
      if(res.code === 1000){
        this.$message.success('修改成功')
        this.$emit('closeFunc','editSuccess')
      }
      // console.log(res,'=====>res')
    },
    //选择毕业时间
    changGruated(data){
      let index = data.indexOf('不限')
      index > -1 ? this.gruatedYear = ['不限'] : ''
    },
    //搜索学校的方法
    async schoolMethod(words){
      this.$refs.schoolInput.focus()
      let res = await actions.company.get_school_autocomplete({'keyword':words})
      if(res.code === 1000){
        let hash = {}
        var newArray = res.data.reduce((item,next)=>{
          hash[next.id] ? "" : hash[next.id] = true && item.push(next)
          return item
        },[])
        this.schoolSelecotrOptions = newArray
      }
    },
    //点击已选择的专业  的删除按钮
    delMajorSelect(data){
      this.qrcodeMaskVisibleForCondition = true
      var index = this.searchMajorList.map(target => target.id).indexOf(data.id)
      if(index > -1){
        this.searchMajorList.splice(index,1)
        if(this.searchMajorList.length === 0 && this.selectedMajorList.length === 0){
          this.selectedMajorList = [{id:0,name:'不限'}]
        }
      }
    },
    //选择学校
    selectSchool(item){
      this.qrcodeMaskVisibleForCondition = true
      var index = this.selectedSchoolList.map(target => target.id).indexOf(item.id)
      if(index > -1){
        this.selectedSchoolList.splice(index,1)
        if(this.selectedSchoolList.length === 0 && this.selectedTagList.length === 0){
          this.selectedTagList = ['不限']
        }
      }else{
        this.selectedSchoolList.push(item)
        if(this.selectedTagList = ['不限']){
          this.selectedTagList = []
        }
      }
    },
    //搜索专业的方法
    async majorMethod(words){
      this.$refs.majorInput.focus()
      let res = await actions.company.get_major_autocomplete({'keyword':words})
      if(res.code === 1000){
        let hash = {}
        var newArray = res.data.reduce((item,next)=>{
          hash[next.id] ? "" : hash[next.id] = true && item.push(next)
          return item
        },[])
        this.majorSelecotrOptions = newArray
      }
    },
    // 搜索专业大类
    majorMethodFunc(val){
      this.majorSelecotrOptions = this.majorSelecotrOptionsCopy.filter(item => {
        return item.name.includes(val)
      })
    },
    //选择院校要求
    selectTags(item){
      this.qrcodeMaskVisibleForCondition = true
      if(item === '不限'){
        this.selectedTagList = ['不限']
        this.selectedSchoolList = []
        this.changeSchoolTagNumber()
        return
      }else{
        if(this.selectedTagList.indexOf('不限') > -1){
          this.selectedTagList.splice(this.selectedTagList.indexOf('不限'),1)
        this.changeSchoolTagNumber()
        }
      }
      var index = this.selectedTagList.indexOf(item)
      if(index > -1){
        this.selectedTagList.splice(index,1)
        this.changeSchoolTagNumber()
      }else{
        this.selectedTagList.push(item)
        this.changeSchoolTagNumber()
      }
    },
    //选择专业要求
    selectMajor(item){
      this.qrcodeMaskVisibleForCondition = true
      if(item.name === '不限'){
        this.selectedMajorList = [{id:0,name:'不限'}]
        this.searchMajorList = []
        this.changeMajorNumber()
        return
      }else{
        if(this.selectedMajorList.map(target => target.id).indexOf(0) > -1){
          this.selectedMajorList.splice(this.selectedTagList.map(target => target.id).indexOf(0),1)
        }
        var index = this.selectedMajorList.map(target => target.id).indexOf(item.id)

        if(index > -1){
          this.selectedMajorList.splice(index,1)
          if(this.searchMajorList.length === 0 && this.searchMajorList.length === 0){
            this.selectedMajorList = [{id:0,name:'不限'}]
          }
        }else{
          if((this.searchMajorList.length + this.selectedMajorList.length) >= 8){
            this.$message.warning('专业最多只能选择 8 个')
            this.changeMajorNumber()
            return
          }
          this.selectedMajorList.push(item)
        }
      }
      this.changeMajorNumber()

    },
    // 选择 曝光职位
    handleSelectTopJob(item) {
      // 关闭上一个监听
      // this.closeCheck()
      // 拆分 获取职位的 token 和 结束时间
      let arr = item.split("&");
      this.selectTopJobToken = arr[0];
      this.selectTopJobEndAt = arr[1];
      // 初始化 选择的曝光时间
      this.selectTopJobTime = null;
      // 初始化 曝光时间范围
      this.initTopJobTimeRange();

      console.log(this.selectTopJobToken, this.selectTopJobTime);
    },
    // 选择 曝光时间
    handleSelectTopTime() {
      // 关闭上一个监听
      // this.closeCheck()
      // 然后更新订单，然后打开新的监听
      // this.updateOrder(this.openCheck)
      console.log(this.selectTopJobToken, this.selectTopJobTime);
    },
    // 初始化 曝光时间范围
    initTopJobTimeRange() {
      // 可选的开始时间
      let startTime = this.moment().format("YYYY-MM-DD");
      // let isHotJob =
      //   !!this.hotJobs[
      //     this.jobArr.find((item) => item.token === this.selectTopJobToken)
      //       .profession_id
      //   ]; // 是否是火爆职位
      let isHotJob = true// 是否是火爆职位
      // 可选的结束时间
      let maxTime = !isHotJob
        ? this.moment(startTime).add(23, "d").format("YYYY-MM-DD")
        : this.moment(this.selectTopJobEndAt).format("YYYY-MM-DD");
      // let maxTime = this.moment(startTime).add(23, 'd')
      // console.log( this.moment(this.selectTopJobEndAt).isBefore(this.moment(startTime).add(23, 'd')));
      // console.log(this.moment(this.selectTopJobEndAt).format('YYYY-MM-DD'), this.moment(startTime).add(27,'d').format('YYYY-MM-DD'));
      // 计算出这个时间范围内有多少天
      let len =
        (Date.parse(maxTime) - Date.parse(startTime)) /
          (1 * 24 * 60 * 60 * 1000) +
        1;
      if (len < 0) return false;
      // 遍历天数 得到时间数组
      let timeArr = [];
      for (let i = 0; i < len; i++) {
        let date = this.moment().add(i, "d").format("YYYY-MM-DD");
        if (
          !isHotJob ||
          new Date(
            this.moment(date).add(7, "d").format("YYYY-MM-DD")
          ).valueOf() <=
            new Date(
              this.moment(this.selectTopJobEndAt).format("YYYY-MM-DD")
            ).valueOf()
        ) {
          timeArr.push(date);
        }
        // this.moment(this.selectTopJobEndAt).format('YYYY-MM-DD')
      }
      // 赋值
      this.selectTopJobTimeRange = timeArr;
    },
    // 检查订单是否支付成功
    async checkOrder(type) {
      if (this.isPending) return false;
      this.isPending = true;
      try {
        let res = await actions.recruit_infos.get_order_status(
          this.type === "phone" ? this.BuyPhoneOrderToken : this.orderToken
        );
        if (res.code === 1000) {
          if (res.data.status === "paid") {
            this.closeCheck();
            this.paidFunc();
          } else {
            type === "buttonClick" &&
              this.$message.error("订单支付失败，请继续支付");
          }
        } else {
          this.$message.error(res.message);
        }
        this.isPending = false;
      } catch (e) {
        console.log(e);
        this.isPending = false;
      }
    },
    //支付成功之后回调
    async getPhoneTimesFunc() {
      let res = await actions.job_deliveries.get_phone_times({});
      if (res.code === 1000) {
        // this.updatePhoneNumber(res.data.check_contact_count )
        this.updatePhoneNumber(res.data.count);
      } else {
        this.updatePhoneNumber(0);
      }
    },
    // 支付成功的回调函数
    async paidFunc() {
      await this.getPhoneTimesFunc();
      this.$emit("paidFunc");
      this.updatePhoneNumberStateFun(false);
      // this.$message({
      //   message: "购买成功",
      //   type: "success",
      // });
    },
    // 关闭弹窗的回调函数
    async closeFunc() {
      await this.getPhoneTimesFunc();
      this.$emit("closeFunc");
      this.updatePhoneNumberStateFun(false);
    },
    // 弹出客服
    errorMessage() {
      let udesk_container = document.querySelector("#udesk_btn a");
      if (udesk_container != null) {
        udesk_container.click();
      }
    },
    //切换购买查看电话次数的卡片
    async changeNumber(val) {
      if (this.currentPhoneCard == val) return;
      this.currentPhoneCard = val;
      this.newPriceText = parseInt(this.getPhoneNumberArr[val].priceCount);
      let params = {
        plan: this.getPhoneNumberArr[val].plan_text,
      };
      let res = await actions.recruit_infos.create_order(params);
      if (res.code === 1000) {
        this.updatePhoneNumberToken(res.data.order_token);
        this.updatePhoneNumberStateFun(true);
      }
    },
  },
  watch: {
    jobIndex: {
      immediate: true,
      handler: function (value) {
        if (value >= 0) {
          // 根据索引，可以当前职位数据
          this.selectTopJobTokenAndEndAt =
            this.jobArr[value].token + "&" + this.jobArr[value].end_at;
          // 初始化 精准曝光时间范围
          // this.handleSelectTopJob(this.selectTopJobTokenAndEndAt)
          // this.closeCheck();
          // 拆分 获取职位的 token 和 结束时间
          let arr = this.selectTopJobTokenAndEndAt.split("&");
          this.selectTopJobToken = arr[0];
          this.selectTopJobEndAt = arr[1];
          // 初始化 选择的曝光时间
          this.selectTopJobTime = this.moment().format("YYYY-MM-DD");
          // 初始化 曝光时间范围
          this.initTopJobTimeRange();
          // 开启监听
          // this.openCheck()
        }
      },
    },
    selectedMajor:{
      handler(newValue,oldValue){
        this.qrcodeMaskVisibleForCondition = true
        this.$refs.majorSelector && this.$refs.majorSelector.blur()
        this.SelectorMajorWords = ''
        if(oldValue.length == 0) return
        if((this.selectedMajor.length + this.selectedMajorList.length) >= 9){
          this.$message.warning('专业最多只能选择 8 个')
          let index = 8 - this.selectedMajorList.length
          let index2 = 7 - this.selectedMajorList.length
          this.selectedMajor = this.selectedMajor.slice(0,index)
          this.searchMajorList = this.searchMajorList.slice(0,index2)
          this.changeMajorNumber()
          return
        }
        // if(newValue.length === 0) return
        //得到新增的或删去的值
        if(newValue.length > oldValue.length){
          var oldId = oldValue.map(item => item.id)
          var result = newValue.filter(item => !oldId.includes(item.id))
        }else{
          var oldId = newValue.map(item => item.id)
          var result = oldValue.filter(item => !oldId.includes(item.id))
        }
        //如果在已给出的 选项列表当中
        if(this.majorList.map(target => target.id).indexOf(result[0].id) > -1){
          this.selectMajor(result[0])
          this.changeMajorNumber()
          return
        }
        //如果已选列表里有 则删去  如果没有则新增
        var index = this.searchMajorList.map(target => target.id).indexOf(result[0].id)
        if(index > -1){
          this.searchMajorList.splice(index,1)
          this.changeMajorNumber()
          if(this.searchMajorList.length === 0 && this.selectedMajorList.length === 0){
            this.selectedMajorList = [{id:0,name:'不限'}]
            this.changeMajorNumber()
          }
        }else{
          this.searchMajorList.push(result[0])
          this.selectedMajorList.map(target => target.id).indexOf(0) > -1 ? this.selectedMajorList.splice(this.selectedMajorList.map(target => target.id).indexOf(0),1) : ''
          this.changeMajorNumber()
        }
      }
    },
    selectedSchool:{
      handler(newValue,oldValue){
        this.qrcodeMaskVisibleForCondition = true
        this.$refs.schoolSelector.blur()
        this.SelectorSchoolWords = ''
        if(this.selectedSchool.length >= 9){
          this.$message.warning('院校最多只能选择 8 个')
          this.selectedSchool = oldValue.slice(0,7)
          this.selectedSchoolList = this.selectedSchool
          this.changeSchoolTagNumber()
          return
        }
        // if(newValue.length === 0) return
        //得到新增的或删去的值
        if(newValue.length > oldValue.length){
          var oldId = oldValue.map(item => item.id)
          var result = newValue.filter(item => !oldId.includes(item.id))
        }else{
          var oldId = newValue.map(item => item.id)
          var result = oldValue.filter(item => !oldId.includes(item.id))
        }
        //如果已选列表里有 则删去  如果没有则新增
        var index = this.selectedSchoolList.map(target => target.id).indexOf(result[0].id)
        if(index > -1){
          this.selectedSchoolList.splice(index,1)
          this.changeSchoolTagNumber()
          if(this.selectedSchoolList.length === 0 && this.selectedTagList.length === 0){
            this.selectedTagList = ['不限']
            this.changeSchoolTagNumber()
          }
        }else{
          this.selectedSchoolList.push(result[0])
          this.selectedTagList.indexOf('不限') > -1 ? this.selectedTagList.splice(this.selectedTagList.indexOf('不限'),1) : ''
          this.changeSchoolTagNumber()
        }
        this.$refs.schoolInput.focus()
      }
    },
    SelectorMajorWords:{
      immediate: true,
      handler(value){
       if(!value) return
       this.$refs.majorSelector && this.$refs.majorSelector.focus()
        let timmer = setTimeout(()=>{
          this.$refs.majorInput && this.$refs.majorInput.focus()  
          clearTimeout(timmer)
        },300)  
        this.majorMethodFunc(value)
      },
    },
    SelectorSchoolWords:{
      handler(value){
        if(value === ''){
          return
        }
        this.$refs.schoolSelector.focus()
        setTimeout(()=>{
          this.$refs.schoolInput.focus()
        },500)
        this.schoolMethod(value)
      }
    },
    selectDegree:{
      handler(value){
        this.qrcodeMaskVisibleForCondition = true
        if(value === '' || value === '中专' || value === '大专') this.multipleNumber.degree = 1
        if(value === '本科') this.multipleNumber.degree = 0.7
        if(value === '硕士') this.multipleNumber.degree = 0.25
        if(value === '博士') this.multipleNumber.degree = 0.03
        if(value === 'MBA') this.multipleNumber.degree = 0.01
      }
    },
    selectWorkExperience:{
      handler(value){
        this.qrcodeMaskVisibleForCondition = true
        // console.log(value)
        if(value === '') this.multipleNumber.work = 1
        if(value === ',1' || value === '0,1' || value === '1,3') this.multipleNumber.work = 0.4
        if(value === '3,5') this.multipleNumber.work = 0.13
        if(value === '5,10') this.multipleNumber.work = 0.17
        if(value === '10,') this.multipleNumber.work = 0.05
      }
    },

    gruatedYear:{
      handler(newValue,oldValue){
        if(newValue.length > oldValue.length){
          var oldId = oldValue.map(item => item.value)
          var result = newValue.filter(item => !oldId.includes(item.value))
        }else if(newValue.length < oldValue.length){
          var oldId = newValue.map(item => item.value)
          var result = oldValue.filter(item => !oldId.includes(item.value))
        }else{
          return
        }
        if(result[0].value === '不限'){
          this.gruatedYear = [{label:'不限',value:'不限'}]
        }else{
          this.gruatedYear.map(target => target.value).indexOf('不限') > -1 ? this.gruatedYear.splice(this.gruatedYear.map(target => target.value).indexOf('不限'),1) : ''
        }
        if(newValue.length === 0){
          this.gruatedYear = [{label:'不限',value:'不限'}]
        }
        if(this.gruatedYear.length > 1 && this.gruatedYear[0].value === '不限'){
          this.gruatedYear.splice(this.gruatedYear.map(target => target.value).indexOf('不限'),1)
        }
        this.changeEduTimeNumber()
      }
    },
    multipleNumber:{
      handler(value){
        this.sumCount()
      },
      deep:true
    }
  },
};
</script>

<style lang="scss" scoped>
.bg {
  position: fixed;
  z-index: 9;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: rgba($color: #000000, $alpha: 0.5);

  .container {
    width: 600px;
    height: 558px;
    box-sizing: border-box;
    box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.03);
    border-radius: 8px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    .header {
      padding: 24px 32px;
      background: #414653;
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
      height: 68px;
      box-sizing: border-box;

      .title-box {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .title {
          display: flex;
          align-items: center;
          font-size: 20px;
          font-weight: 600;
          color: #ffffff;

          .icontishi1 {
            position: relative;
            font-size: 16px;
            color: #9c9c9c;
            margin-left: 6px;
            cursor: pointer;

            &:hover {
              color: #ffffff;

              p {
                display: block;
              }
            }

            p {
              display: none;
              position: absolute;
              left: 26px;
              top: -8px;
              width: 288px;
              background: #ffffff;
              font-size: 12px;
              line-height: 18px;
              padding: 8px 18px;
              font-weight: 400;
              color: #404040;
              border-radius: 3px;

              &::before {
                content: "";
                position: absolute;
                top: 22%;
                left: -10px;
                border-width: 5px;
                border-style: solid;
                border-color: #ffffff;
                border-top-color: transparent;
                border-bottom-color: transparent;
                border-left-color: transparent;
              }
            }
          }
        }

        .iconquxiao {
          font-size: 14px;
          color: rgba(255, 255, 255, 0.7);
          cursor: pointer;
        }
      }

      .subtitle {
        font-size: 14px;
        font-weight: 400;
        color: #ffffff;
        margin-top: 12px;
      }
    }
    .flexBox {
      // display: flex;
      // width: 830px;
      .content {
        height: 392px;
        .scroll-box {
          padding-top: 12px;
          // height: 392px;
          overflow-y: scroll;
          box-sizing: border-box;
          width: 100%;
          .item-box {
            padding: 28px 50px 0;
            display: flex;
            justify-content: space-between;
            .item {
              display: flex;
              flex-direction: column;
              align-items: center;
              .item-img {
                width: 58px;
                margin-bottom: 12px;
              }
              .item-title {
                font-size: 14px;
                font-weight: 500;
                color: #404040;
                line-height: 20px;
                margin-bottom: 4px;
              }
              .item-subtitle {
                font-size: 12px;
                font-weight: 400;
                color: #9c9c9c;
                line-height: 17px;
              }
            }
          }
        }
        .scroll-box::-webkit-scrollbar {
          display: none; /* Chrome Safari */
        }

        .form-box {
          padding: 0 32px;

          .top-description-box {
            display: flex;
            margin-bottom: 12px;

            .top-description-text {
              flex: 1;
              background: rgba(65, 70, 83, 0.04);
              font-size: 14px;
              font-weight: 400;
              color: #404040;
              line-height: 22px;
              padding: 12px 20px;
              border-radius: 4px;
            }

            .top-description-button {
              position: relative;
              width: 58px;
              height: 68px;
              cursor: pointer;

              &:hover .top-description-content {
                display: block;
                z-index: 100;
              }
            }

            .top-description-content {
              display: none;
              position: absolute;
              top: 0px;
              right: -328px;
              width: 333px;
              height: 328px;
              padding: 20px 20px 35px;
              // background: #ffffff;
              box-sizing: border-box;
              background-image: url("https://files.wondercv.com/hr-pc/top-job-tips-bg.png");
              background-size: cover;
              background-repeat: no-repeat;

              .top-description-content-img {
                width: 260px;
                height: 157px;
                background: #f4f4f4;
                border-radius: 6px;
                margin-left: 20px;
                margin-bottom: 20px;
                margin-top: 10px;
              }

              .top-description-content-text {
                width: 260px;
                font-size: 14px;
                font-weight: 400;
                margin-left: 20px;
                color: #404040;
                line-height: 24px;
              }
            }
          }

          .form-item {
            display: flex;
            align-items: center;
            margin-bottom: 24px;
            position: relative;
            .form-label {
              font-size: 14px;
              font-weight: 400;
              color: #606060;
              margin-right: 24px;
            }

            .form-input {
              flex: 1;
            }

            .grad-input{
              position: absolute;
              top:1px;left: 96px;
              width:407px;
              height:38px;
              overflow: hidden;
              background: #fff;
              border-radius: 10px;
              padding: 0 15px;
              color: #606060;
              line-height:38px;
              text-overflow: ellipsis;
            }
          }
          .form-item-condition {
            display: flex;
            align-items: flex-start;
            margin-bottom: 24px;
            width: 100%;

            .form-label {
              font-size: 14px;
              font-weight: 400;
              color: #606060;
              margin-right: 24px;
              line-height: 32px;
            }
            .conditions {
              flex: 1;

              .selector-label {
                color: #9c9c9c;
                font-size: 12px;
                margin-right: 12px;
                box-sizing: border-box;
              }

              .conditions-info {
                .info-selector {
                  display: flex;
                  flex-flow: row nowrap;
                  justify-content: space-between;
                  align-items: center;
                  .selector-info {
                    display: flex;
                    flex-flow: row nowrap;
                    justify-content: flex-start;
                    align-items: center;
                    /deep/ .el-select {
                      width: 145px;
                    }
                  }
                }
              }
            }

            //   .form-input {
            //     flex: 1;
            //   }
          }
        }

        .order-info {
          padding: 24px;
          margin: 24px 32px 0;
          background: #f5f6fa;
          border-radius: 8px;

          h4 {
            height: 16px;
            line-height: 16px;
            font-size: 16px;
            font-weight: 500;
            color: #404040;
            margin-bottom: 15px;
          }

          p {
            height: 16px;
            line-height: 16px;
            margin-bottom: 12px;
            font-size: 14px;
            font-weight: 400;
            color: #606060;

            &:last-of-type {
              margin-bottom: 0;
            }
          }
        }
      }

      .footer {
        // display: flex;
        // justify-content: space-between;
        width: 260px;
        //   border-radius: 8px;
        //   border: 1px solid #F5F6FA;
        //   padding: 16px;
        margin: 25px 0;

        .footer-left {
          // display: flex;

          .qrcode-box {
            position: relative;

            ::v-deep .qrcode {
              img {
                display: block;
                width: 100px;
                margin: 0 auto;
              }
            }

            .qrcode-mask {
              position: absolute;
              top: -2px;
              left: -2px;
              width: 104px;
              height: 104px;
              filter: blur(2px);
              background: rgba(255, 255, 255, 0.85);
            }

            .qrcode-mask-text {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              font-size: 14px;
              white-space: nowrap;
              text-align: center;
              font-weight: 400;
              color: #404040;
              line-height: 24px;
            }
          }

          .price-info {
            display: flex;
            flex-direction: column;
            justify-content: center;
            text-align: center;
            //   margin-left: 18px;
            .price-value {
              font-size: 28px;
              font-weight: 600;
              color: #ff6644;
              line-height: 28px;
              margin-bottom: 12px;
              margin-top: 20px;
            }

            .price-img {
              margin-bottom: 12px;
              img {
                display: inline-block;
                width: 24px;
                border-radius: 6px;

                &:first-of-type {
                  margin-right: 10px;
                }
              }
            }

            .price-text {
              font-size: 12px;
              font-weight: 400;
              color: #404040;
              white-space: nowrap;
              margin-bottom: 56px;
            }
          }
        }

        .footer-right {
          display: flex;
          flex-direction: column;
          align-items: center;

          .paid-button {
            &:hover {
              opacity: 0.8;
            }
            display: inline-block;
            padding: 8px 24px;
            font-size: 14px;
            color: #ffffff;
            line-height: 20px;
            //background: linear-gradient(180deg, #FF9F79 0%, #4183FF 100%);
            background: #ff6644;
            border-radius: 2px;
            margin-bottom: 12px;
            margin-top: 7px;
            cursor: pointer;
          }
          .paid-button:hover {
            opacity: 0.8;
          }
          .paid-text {
            font-size: 12px;
            font-weight: 400;
            color: #404040;
            line-height: 20px;
            white-space: nowrap;
          }
        }
      }
    }
    .dialog-buttons{
      display: flex;
      flex-flow: row nowrap;
      justify-content: flex-end;
      align-items: center;
      height: 94px;
      font-size: 14px;
      p{
        cursor: pointer;
        width: 82px;
        height: 34px;
        text-align: center;
        line-height: 34px;
        border-radius: 2px;
      }
      p:hover{
        opacity: 0.8;
      }
      .cancle-button{
        color: #404040;
        border: 1px solid #CFCFCF;
        margin-right: 16px;
      }
      .confirm-button{
        color: #fff;
        background: #4183FF;
        margin-right: 32px;
      }
    }
  }
}

::v-deep.el-select-dropdown__item.selected {
  .select-item-post,
  .select-item-info,
  .select-item-date1,
  .select-item-date2 {
    color: #4183ff;
  }
}

.select-item-post {
  color: #606060;
  margin-right: 12px;
}
.select-item-info {
  color: #9c9c9c;
}
.select-item-date1 {
  color: #606060;
  margin-right: 9px;
}
.select-item-date2 {
  color: #9c9c9c;
}
.item-flex-box {
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  box-sizing: border-box;
  cursor: pointer;
  .times_card {
    width: 100px;
    height: 117px;
    background: #fbf8f0;
    border-radius: 5px;
    position: relative;
    .phone_discount {
      height: 20px;
      background: linear-gradient(90deg, #ff9c62 0%, #ff6030 100%);
      border-radius: 9px 1px 9px 1px;
      line-height: 20px;
      font-size: 11px;
      color: #fbf8f0;
      position: absolute;
      top: -10px;
      left: -1px;
      padding: 0 7px;
    }
    .box-border {
      border: 1px solid #f1e5d8;
    }
    .phone_times {
      height: 70px;
      text-align: center;
      padding-top: 16px;
      box-sizing: border-box;
      .phone_times_number {
        font-size: 18px;
        line-height: 21px;
        color: #404040;
        font-weight: bold;
        span {
          font-weight: bold;
          font-size: 11px;
        }
      }
      .price_one {
        color: #404040;
        margin-top: 7px;
        transform: scale(0.9);
      }
    }
    .phone_prices {
      padding: 8px;
      background: linear-gradient(132deg, #fff2e2 0%, #e3c8a9 100%);
      border-radius: 0px 0px 4px 4px;
      height: 47px;
      box-sizing: border-box;
      .opacity6 {
        opacity: 0.6;
      }
      p {
        color: #9c643e;
        font-size: 14px;
        font-weight: 600;
        line-height: 14px;
        margin-bottom: 5px;
      }
      span {
        display: block;
        font-size: 11px;
        transform: scale(0.9);
        color: #9c643e;
        text-decoration: line-through;
        padding: 0 3px;
      }
    }
  }
  .times_card_active {
    .box_border {
      border: 1px solid #9c643e;
    }
  }
  .box_border {
    position: relative;
    border-radius: 5px;
    border: 1px solid #f1e5d8;
  }
  .box_border:hover {
    border: 1px solid #9c643e;
  }
}
.z100 {
  z-index: 100;
}
.conditions-title {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  color: #4183FF;
  background: #F5F8FF;
  padding: 8px 12px;
  margin-bottom: 20px;
  border-radius: 2px;

  p {
    margin-left: 8px;
    font-size: 14px;
  }


}
.warning{
  background:  #FFF6F4;
  color: #FF6644;
}

.school-selector {
  position: relative;
  /deep/ .el-select {
    width: 100%;
    // margin-left: 60px;
    border: 1px solid #ececec;
    border-radius: 4px;
    margin-top: 10px;
    box-sizing: border-box;
  }
  /deep/ .el-input__inner {
    border: none;
  }
  .selected-school-list {
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-start;
    align-items: center;
    width: 429px;
    box-sizing: border-box;
    .items{
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      align-items: center;
      padding: 0 16px;
      height: 28px;
      color:#4183FF;
      border: 1px solid #4183FF;
      border-radius: 16px;
      margin: 10px 10px 0 0;
      max-width: 128px;
      box-sizing: border-box;
      p{
        max-width: 70px;
        white-space: nowrap;
        overflow:hidden;
        text-overflow: ellipsis;
        font-size: 14px;
        margin-right:8px;
      }
      .iconguanbi{
        cursor: pointer;
      }
    }
  }
  .input-box{
    position: absolute;left: 1px;bottom:1px;
    width:429px;
    height: 40px;
    background: #fff;
    z-index: 100;
    input{
      width: 100%;
      height: 40px;
      padding-left: 16px;
      box-sizing: border-box;
    }
  }
}

.choose-info {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  .choose-item-list {
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-items: center;
    p {
      padding: 0 16px;
      cursor: pointer;
    }
    .items {
      border: 1px solid #ececec;
      border-radius: 16px;
      color: #606060;
      font-size: 14px;
      margin-right: 10px;
      height: 28px;
      box-sizing: border-box;
      line-height: 28px;
    }
    .active {
      border: 1px solid #669bff;
      color: #4183ff;
    }
    .iconjia1 {
      color: #9c9c9c;
      font-size: 12px;
      cursor: pointer;
      width: 28px;
      height: 28px;
      border: 1px solid #ececec;
      border-radius: 50%;
      box-sizing: border-box;
      text-align: center;
      line-height: 26px;
    }
  }
}
.school-selector{
  /deep/ .el-tag{
    display: none;
  }
}
/deep/ .el-select{
  flex: 1;
}
.gradactive{
  color: #4183FF !important;
}
.iconxuanzhong{
  color: #4183FF !important;
}
/deep/ .time-selector{
  .el-select__tags{
    display: none;
  }
}
.graduation{
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  .iconweixuanzhong{
    color:#ECECEC;
  }
  p{
    margin-left: 12px;
    color: #9C9C9C;
  }
}
</style>
